import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";

import "jquery";

// Pastikan jQuery tersedia secara global
window.$ = $;
window.jQuery = $;

// Import SmartWizards
import "smartwizard/dist/js/jquery.smartWizard.min.js";
// Import Magnific Popup
import "magnific-popup/dist/jquery.magnific-popup.min.js";

import Chart from "chart.js";
window.Chart = Chart;
// import "chartjs-plugin-labels";

import firebase from "firebase/app";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAu4LT5yVnxihf4L5apM76Yc4q57kalcsU",
  authDomain: "chat-siplah.firebaseapp.com",
  databaseURL:
    "https://chat-siplah-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "chat-siplah",
  storageBucket: "chat-siplah.appspot.com",
  messagingSenderId: "847474973184",
  appId: "1:847474973184:web:7293445dd4adba1cdb56e5",
  measurementId: "G-N81Y8G8V1M",
};
firebase.initializeApp(firebaseConfig);

import * as VueGoogleMaps from "vue2-google-maps";
// AIzaSyCRlNTo8zNzQD1w970vCDbU5wtTHQUkGDk
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDh-5EKMNBSCu8gexlq8CyRisLifCxZlJY",
    // key: "AIzaSyCRlNTo8zNzQD1w970vCDbU5wtTHQUkGDk",
    libraries: "places",
  },
});

import moment from "moment";
Vue.prototype.moment = moment;

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {});

import Fragment from "vue-fragment";
Vue.use(Fragment.Plugin);

import VueContentPlaceholders from "vue-content-placeholders";
Vue.use(VueContentPlaceholders);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import Toast from "vue-toastification";

const options = {
  transition: "Vue-Toastification__fade",
  position: "top-right",
  timeout: 10000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
  pauseOnHover: false,
  draggable: true,
  draggablePercent: 0.35,
  showCloseButtonOnHover: true,
  hideProgressBar: true,
  closeButton: "button",
  icon: false,
  rtl: false,
  maxToasts: 5,
};

Vue.use(Toast, options);
import "vue-toastification/dist/index.css";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
const optionsSwal = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
};
Vue.use(VueSweetalert2, optionsSwal);

import InfiniteLoading from "vue-infinite-loading";

Vue.use(InfiniteLoading, {
  /* options */
});

import VueCurrencyInput from "vue-currency-input";

const pluginOptions = {
  /* see config reference */
  globalOptions: {
    locale: "de-DE",
    currency: null,
    distractionFree: false,
    precision: 0,
  },
};

Vue.use(VueCurrencyInput, pluginOptions);

import "@lottiefiles/lottie-player";

import "./plugins/table";

import "bootstrap/dist/js/bootstrap.min.js";

import "./plugins/bootstrap-toggle/bootstrap-toggle.min.css";

import "./plugins/bootstrap-toggle/bootstrap-toggle.min.js";

axios.defaults.baseURL = "https://siplah.eurekabookhouse.co.id/api/";

Vue.config.productionTip = false;
Vue.config.silent = true;

const token = localStorage.getItem("token");

import { setHeaderToken } from "./utils/auth";

if (token) {
  setHeaderToken(token);
}

store
  .dispatch("get_user", token)
  .then(() => {
    store.dispatch("get_order", token);
  })
  .then(() => {
    store.dispatch("get_notif", token);
  })
  .then(() => {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount("#app");
  })
  .catch((error) => {
    console.error(error);
  });
